import  { useState, useEffect } from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import { useDispatch } from 'react-redux';
import { Spiral } from 'ldrs/react'
import 'ldrs/react/Spiral.css'
import NotFound from './pages/NotFound';
import { Hourglass } from 'ldrs/react'
import TermsAndConditions from './pages/TermsAndConditions';
import 'ldrs/react/Hourglass.css'
import ScrollToTop from './components/ScrollToTop';
import About from './pages/About';
import PrivacyPolicy from './pages/PrivacyPolicy';
  import CarwashAppointment from './pages/CarwashAppointment';
import CarpetPickup from './pages/CarpetPickup';
import WaterRefill from './pages/WaterRefill';
import Services from './pages/Services';
 import AboutPage from './pages/About';
import { DotPulse } from 'ldrs/react'
import 'ldrs/react/DotPulse.css'

// Default values shown
  
 
function App() {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
    useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 500);
  
    return () => clearTimeout(timeout);
  }, []);
  

 
 
  
  return (
    <>
      <BrowserRouter>

      {loading ? (
        <div className="loader position-relative ">


        <DotPulse
          size="43"
          speed="1.3"
          color="black" 
        />
        </div>
     ) : (
        <>
        <ScrollToTop/>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about-us" element={<AboutPage />} />
  
            <Route path="contact-us" element={<Contact />} />
             <Route path="carwash-appointment" element={<CarwashAppointment />} />
              <Route path="carpet-pickup" element={<CarpetPickup />} />
              <Route path="water-refill" element={<WaterRefill />} />
              <Route path="services" element={<Services />} />

          <Route path='privacy-policy' element={<PrivacyPolicy/>}/>
           <Route path='terms-and-conditions' element={<TermsAndConditions/>}/>
  
 
             <Route path="*" element={< NotFound/>} />

          </Route>
  

   
    
        </Routes>
          </>
        )}
      </BrowserRouter>
    </>
  );
}

export default App;